<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div style="display: flex; justify-content: space-between">
          <button class="btn btn-primary" @click="showAddModal">Добавить продукт</button>
          <div style="display: flex; align-items: center;">
            <argon-input
                id="searchField"
                placeholder="Поиск"
                v-model="searchText"
                :value="searchText"
                style="margin-right: 10px;"
                @input="setSearchText"
                @keyup.enter="startSearch"
            />
            <SortTemplate  :options="sortOptions"
                           v-model:sortValue="productSort"
                           :change-sort-action="setSortType"/>
            <button class="btn btn-primary" @click="startSearch">Искать</button>
          </div>
        </div>
        <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
          <div v-if="this.isLoading">
            <CircleProgress/>
          </div>
        </transition>
        <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
          <div v-if="!this.isLoading">
            <Table
                :availableEdit="true"
                :columns="columns"
                :data="products"
                :editAction="showEditModal"
                :deleteAction="deleteProduct"
                :tableName="'Товары'"
            />

            <div style="display: flex; justify-content: flex-end; margin-top: 10px;">
              <button class="btn btn-primary" style="margin-right: 10px;" @click="previousPage" :disabled="productPaginationStart <= 0"><i
                  class="ni ni-bold-left"></i></button>
              <button class="btn btn-primary" @click="nextPage" :disabled="productListSize > products.length"><i
                  class="ni ni-bold-right"></i></button>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
      <div v-if="showModal">
        <div class="modal" :class="{ 'd-block': showModal }" id="productModal" tabindex="-1" role="dialog"
             aria-labelledby="productModalLabel" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="productModalLabel">{{ editingProduct ? 'Редактировать' : 'Добавить' }}
                  продукт</h5>
                <b-button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                  <span aria-hidden="true">&times;</span>
                </b-button>
              </div>
              <div class="modal-body">
                <form @submit.prevent="editingProduct ? editProduct() : addProduct()">
                  <label for="name" style="font-weight: bold;">Название</label>
                  <argon-input
                      id="name"
                      v-model="productName"
                      :value="productName"
                      placeholder="Название"
                      :isRequired="true"
                      @change="setProductName"
                  />

                  <label for="equipment-cos" style="font-weight: bold;">Стоимость оборудования</label>
                  <argon-input
                      id="equipment-cost"
                      :value="productEquipmentCost"
                      v-model="productEquipmentCost"
                      type="text"
                      placeholder="Стоимость оборудования"
                      :isRequired="true"
                      @change="setProductEquimentCost"
                  />

                  <label for="rent-cost" style="font-weight: bold;">Стоимость аренды</label>
                  <argon-input
                      id="rent-cost"
                      :value="productRentCost"
                      v-model="productRentCost"
                      type="text"
                      placeholder="Стоимость аренды"
                      :isRequired="true"
                      @change="setProductRentCost"
                  />

                  <label for="description" style="font-weight: bold;">Описание</label>
                  <argon-input
                      id="description"
                      :value="productDescription"
                      v-model="productDescription"
                      type="textarea"
                      placeholder="Описание"
                      @change="setProductDescription"
                  />

                  <label for="complectation" style="font-weight: bold;">Комплектация</label>
                  <argon-input
                      id="complectation"
                      :value="productComplectation"
                      v-model="productComplectation"
                      placeholder="Комплектация"
                      @change="setProductComplectaion"
                  />

                  <label for="complectation" style="font-weight: bold;">Серийный номер</label>
                  <argon-input
                      id="serial-number"
                      :value="productSerialNumber"
                      v-model="productSerialNumber"
                      placeholder="Серийный номер"
                      @change="setProductSerialNumber"
                  />

                  <label for="quantity" style="font-weight: bold;">Количество</label>
                  <argon-input
                      id="quantity"
                      :value="productQty"
                      v-model="productQty"
                      type="number"
                      placeholder="Количество"
                      :isRequired="true"
                      @change="setProductQty"
                  />

                  <argon-button
                      variant="fill"
                      color="primary"
                      type="submit"
                  >{{ editingProduct ? 'Сохранить изменения' : 'Добавить' }}
                  </argon-button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import CircleProgress from "./components/CircleProgress.vue";
import Table from "./components/Table.vue";
import axios from "@/axios";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import velocity from "velocity-animate";
import SortTemplate from "../components/standart/SortTemplate.vue";

export default {
  name: "ProductsTable",
  components: {
    SortTemplate,
    Table,
    ArgonInput,
    ArgonButton,
    CircleProgress
  },
  data() {
    return {
      products: [],
      columns: ['ID',
        'Название',
        'Стоимость Аренды',
        'В наличии',
        'Количество',
        'Доп. инфо',
      ],
      sortOptions: [
        { key: 'null', value: 'null', text: 'Все' },
        { key: 'ASC', value: 'ASC', text: 'От А до Я' },
        { key: 'DESC', value: 'DESC', text: 'От Я до А' },
      ],
      showModal: false,
      editingProduct: null,
      formErrors: {
        name: false,
        equipmentCost: false,
        rentCost: false,
        qty: false
      },
      productData: {
        name: '',
        equipment_cost: '',
        rent_cost: '',
        description: '',
        complectation: '',
        serial_number: '',
        qty: ''
      },
      editData: {
        name: '',
        equipmentCost: '',
        rentCost: '',
        description: '',
        complectation: '',
        serialNumber: '',
        qty: ''
      }
    };
  },
  computed: {
    productName: {
      get() {
        return this.$store.state.productCreateName;
      },
    },
    searchText: {
      get() {
        return this.$store.state.productSearchText;
      }
    },
    productEquipmentCost: {
      get() {
        return this.$store.state.productCreateEquipmentCost;
      },
    },
    productRentCost: {
      get() {
        return this.$store.state.productCreateRentCost;
      },
    },
    productDescription: {
      get() {
        return this.$store.state.productCreateDescription;
      },
    },
    productComplectation: {
      get() {
        return this.$store.state.productCreateComplectation;
      },
    },
    productSerialNumber: {
      get() {
        return this.$store.state.productCreateSerialNumber;
      },
    },
    productQty: {
      get() { return this.$store.state.productCreateQty; },
      set(value) {
        this.$store.commit('updateProductCreateQty', value);
      }
    },
    isLoading: {
      get() {
        return this.$store.state.isProductLoading;
      },
    },
    productId: {
      get() {
        return this.$store.state.productId;
      },
    },

    productListSize: {
      get() {
        return this.$store.state.productListSize
      }
    },
    productPaginationStart: {
      get() {
        return this.$store.state.productPaginationStart
      }
    },
    productSort: {
      get() {
        return this.$store.state.productSortType
      }
    }
  },
  methods: {

    fetchData() {
      this.updateProductIsLoading(true);
      let url = '/api/product?length=' + this.productListSize + "&start=" + this.productPaginationStart;
      if (this.searchText != null && this.searchText.length >= 3) {
        url = '/api/product?length='+this.productListSize + "&search=" + this.searchText;
        this.clearSearchText();
        if(this.productPaginationStart != 0) {
          this.resetPagination();
        }
      }
      if (this.productSort != null && this.productSort != "null") {
        url = url + "&sort=" + this.productSort;
      }
      axios.get(url).then(response => {
        let products = response.data.map(product => {
          return {
            id: product.id,
            name: product.name,
            rentCost: product.rentCost,
            dostupno: product.dostupno,
            activeBron: product.activeBron,
            active: product.active,
            qty: product.qty,
            equipmentCost: product.equipmentCost,
            description: product.description,
            complectation: product.complectation,
            serialNumber: product.serialNumber,
            bron: product.bron,
            orders: product.orders
          };
        });
        this.products = products;
        this.updateProductIsLoading(false);
      }).catch(error => {
        console.error("Ошибка загрузки данных: ", error);
        this.updateProductIsLoading(false);
      });
    },
    deleteProduct(product) {
      axios.delete(`/api/product/${product.id}`).then(() => {
        this.fetchData();
      });
    },
    setSortType(sortType) {
      this.$store.commit('updateProductSortType', sortType.target.value);
    },
    showAddModal() {
      this.editingProduct = null;
      this.showModal = true;
    },
    showEditModal(product) {
      this.editingProduct = product;
      this.previousQty = product.qty;
      this.setProductEditData(product);
      this.showModal = true;
    },
    startSearch() {
        this.fetchData();
    },
    validateForm() {
      this.formErrors.name = !this.productName;
      this.formErrors.equipmentCost = !this.productEquipmentCost;
      this.formErrors.rentCost = !this.productRentCost;
      this.formErrors.qty = !this.productQty || this.productQty <= 0;

      console.log("Name error: " + this.formErrors.name);
      console.log("Cost error: " + this.formErrors.equipmentCost);
      console.log("Rent error: " + this.formErrors.rentCost);
      console.log("QTY error: " + this.formErrors.qty);

      return !(this.formErrors.name || this.formErrors.equipmentCost || this.formErrors.rentCost || this.formErrors.qty);
    },
    addProduct() {
      if (this.validateForm()) {
        this.productData.name = this.productName;
        this.productData.qty = this.productQty;
        this.productData.equipment_cost = this.productEquipmentCost;
        this.productData.rent_cost = this.productRentCost;
        this.productData.description = this.productDescription;
        this.productData.complectation = this.productComplectation;
        this.productData.serial_number = this.productSerialNumber;

        axios.post('/api/product/new', this.productData).then(() => {
          this.showModal = false;
          this.clearProduct();
          this.fetchData();
        });
      }
    },
    editProduct() {
      if (this.validateForm()) {
        this.editData.name = this.productName;
        this.editData.qty = this.productQty;
        this.editData.equipmentCost = this.productEquipmentCost;
        this.editData.rentCost = this.productRentCost;
        this.editData.description = this.productDescription;
        this.editData.complectation = this.productComplectation;
        this.editData.serialNumber = this.productSerialNumber;
        axios.put(`/api/product/${this.productId}/edit`, this.editData).then(() => {
          this.showModal = false;
          this.fetchData();
        });
      }
    },

    clearSearchText() {
      this.$store.commit('updateClientSearchText', null);
    },

    setProductName(payload) {
      this.$store.commit('updateProductCreateName', payload.target.value);
    },
    setProductDescription(payload) {
      this.$store.commit('updateProductCreateDescription', payload.target.value);
    },
    setProductComplectaion(payload) {
      this.$store.commit('updateProductCreateComplectation', payload.target.value);
    },
    setProductEquimentCost(payload) {
      const regex = /^\d+(\.\d{1,2})?$/;
      if (regex.test(payload.target.value)) {
        this.$store.commit('updateProductCreateEquipmentCost', payload.target.value);
      }
      else {
        this.$store.commit('updateProductCreateEquipmentCost', 0);
      }
    },
    setProductRentCost(payload) {
      const regex = /^\d+(\.\d{1,2})?$/;
      if (regex.test(payload.target.value)) {
        this.$store.commit('updateProductCreateRentCost', payload.target.value);
      }
      else {
        this.$store.commit('updateProductCreateRentCost', 0);
      }
    },
    setProductSerialNumber(payload) {
      this.$store.commit('updateProductCreateSerialNumber', payload.target.value);
    },
    setProductQty(payload) {
      const newQty = payload.target.value;
      const passwordCookie = this.getCookie("passwordAccepted");
      if (passwordCookie === "true") {
        this.previousQty = newQty;
        this.productQty = newQty;
      } else {
        const pass = prompt('Введите пароль');
        if (pass === "30061978") {
          alert("Доступ разрешен");
          this.previousQty = newQty;
          this.productQty = newQty;
          const date = new Date();
          date.setTime(date.getTime() + (30 * 60 * 1000));
          document.cookie = "passwordAccepted=true; expires=" + date.toUTCString() + "; path=/";
        } else {
          alert("Пароль не верен. Введенное значение не будет сохранено");
          this.productQty = this.previousQty;
          this.$nextTick(() => {
            document.getElementById("quantity").value = this.previousQty;
          });
        }
      }
    },

    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    },
    setSearchText(payload) {
      this.$store.commit('updateProductSearchText', payload.target.value);
    },
    clearProduct() {
      this.$store.commit('clearProductCreate');
    },
    resetPagination() {
      this.$store.commit('updateProductPaginationStart', 0);
    },

    nextPage() {
      const currentStep = this.productPaginationStart + this.productListSize;
      this.$store.commit('updateProductPaginationStart', currentStep);
      this.fetchData();
    },
    previousPage() {
      const currentStep = this.productPaginationStart - this.productListSize;
      this.$store.commit('updateProductPaginationStart', currentStep);
      this.fetchData();
    },
    closeModal() {
      this.showModal = false;
      this.clearProduct();
    },
    updateProductIsLoading(active) {
      this.$store.commit('updateProductIsLoading', active);
    },
    setProductEditData(product) {
      this.$store.commit('setProductEditData', product);
    },
    beforeEnter(el) {
      el.style.opacity = 0;
    },
    enter(el, done) {
      velocity(el, {opacity: 1}, {duration: 500, complete: done});
    },
    leave(el, done) {
      velocity(el, {opacity: 0}, {duration: 500, complete: done});
    }
  },
  mounted() {
    this.fetchData();
  },
};
</script>
